import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { take, takeUntil } from "rxjs/operators";
import { SessionService } from "src/app/session.service";
import { UiService } from "src/app/ui/ui.service";
import { DashboardService } from "../../dashboard.service";
import { GenericWidgetComponent } from "../generic-widget/generic-widget.component";
import { AppService } from "src/app/apps/app.service";
import { MatDialog } from "@angular/material/dialog";
import { forkJoin } from "rxjs";
import { CustomerComponent } from "../../../customers/customer/customer.component";
import { faFileImage } from "@fortawesome/free-regular-svg-icons";
import { find, get } from "lodash";
import { UtilService } from "src/app/util/util.service";

@Component({
  selector: "app-on-property-widget",
  templateUrl: "./on-property-widget.component.html",
  styleUrls: ["./on-property-widget.component.scss"],
})
export class OnPropertyWidgetComponent extends GenericWidgetComponent {
  searchValue = "";
  onPropertyUsers: any = [];
  filteredOnPropertyUsers: any;

  faFileImage = faFileImage;

  constructor(
    private route: ActivatedRoute,
    private DashboardService: DashboardService,
    private SessionService: SessionService,
    private uiService: UiService,
    private router: Router,
    private AppService: AppService,
    private dialog: MatDialog,
    private utilSvc: UtilService
  ) {
    super();
  }

  get accountID() {
    return this.SessionService.currentAccountValue!.accountID;
  }

  get accountAppID() {
    return this.SessionService.currentAppValue!.id;
  }

  get currentAccount() {
    return this.SessionService.currentAccountValue;
  }

  async ngOnInit(): Promise<any> {}

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.elementLoader
      .waitForEvent(
        this.DashboardService.getOnProperty(this.accountID, this.accountAppID),
      )
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((res: any) => {
        Promise.all(
          res.map(async (user: any) => {
            let img = this.image(user);
            if (img !== null) {
              try {
                await this.checkImage(img);
                user.image = img;
              } catch (e) {
                user.image = "assets/png/unknown.jpeg";
              }
            } else {
              user.image = "assets/png/unknown.jpeg";
            }

            return user;
          }),
        ).then((res) => {
          this.onPropertyUsers = res;
          this.filteredOnPropertyUsers = this.onPropertyUsers;
        });
      });
  }

  applyFilter() {
    if (
      this.searchValue === null ||
      this.searchValue === undefined ||
      this.searchValue === ""
    ) {
      this.filteredOnPropertyUsers = this.onPropertyUsers;
    } else {
      this.filteredOnPropertyUsers = this.onPropertyUsers.filter(
        (user: any) => {
          const name =
            user.first_name || user.last_name
              ? user.first_name.toLowerCase() +
                " " +
                user.last_name.toLowerCase()
              : "no name";

          return name.includes(this.searchValue.toLowerCase());
        },
      );
    }
  }

  checkImage(url: string) {
    return new Promise((resolve, reject) => {
      var image = new Image();
      image.onload = () => {
        if (image.width > 0) {
          resolve(url);
        }
      };
      image.onerror = () => {
        reject("Image not found");
      };
      image.src = url;
    });
  }

  image(user: any){
    let cloudinaryImage = find(this.currentAccount?.catalog.app_users?.profile, {id: "image", _type: "CloudinaryImage"})
    if(this.utilSvc.isValidHttpUrl(user.profile.image)){
      //console.log("valid user.profile.image", user.profile.image)
      return user.profile.image
    } else if (cloudinaryImage !== undefined) {
      //console.log("cloudinaryImage", cloudinaryImage)
      let imagePath = get(user, cloudinaryImage.field.replace("appUser.", ""))
      if(imagePath === "" || imagePath === undefined || imagePath === null){
        return null;
      }
      return `https://res.cloudinary.com/${cloudinaryImage.cloud_name}/image/upload/${imagePath}`
    }
    return null
  }

  goToUser(row: any) {

    this.uiService.waitForEvent(forkJoin(

      // Anonyous
      row.id === null ? 
      [
        this.AppService.getAppDevice(
          this.SessionService.currentAccountValue!.accountID,
          row.id,
        ),
        this.AppService.getAppDeviceLocationHistory(
          this.SessionService.currentAccountValue!.accountID,
          row.id,
        ).pipe(take(1)),
        this.AppService.getAppDeviceSignalHistory(
          this.SessionService.currentAccountValue!.accountID,
          row.id,
        ).pipe(take(1))
      ] 
        : 

      // Authenticated
      [
      this.AppService.getUser(
        this.SessionService.currentAccountValue!.accountID,
        row.id,
      ),
      this.AppService.getAppUserLocationHistory(
        this.SessionService.currentAccountValue!.accountID,
        row.id,
      ).pipe(take(1)),
      this.AppService.getAppUserSignalHistory(
        this.SessionService.currentAccountValue!.accountID,
        row.id,
      ).pipe(take(1))
    ])).subscribe((customer: any) => {
      const dialogRef = this.dialog.open(CustomerComponent, {
        panelClass: 'app-full-bleed-dialog',
        width: "100%",
        height: "80%",
        data: {
          customer: customer[0],
          locationHistory: customer[1],
          signalHistory: customer[2]
        }
       });
       dialogRef.afterClosed().subscribe((result) => {
        if(result === "sendPrivateBroadcast"){
          let cust = customer[0];
          this.router.navigate(["createBroadcast"], {
            state: {
              audience: {
                count: 1,
                customer_id: cust.id,
                device_count: cust.appDevices?.length ?? 0,
                facility_id: this.SessionService.facilitiesValue!.map((facility) => {
                  return facility.id;
                }),
                single_customer_qs: true,
                name: cust.first_name && cust.last_name ? `${cust.first_name} ${cust.last_name}` : "No customer name",
              },
            },
            relativeTo: this.route.parent,
          });
        }
       });
    })
  }
}
